import { render, staticRenderFns } from "./ProfileSettingsForm.vue?vue&type=template&id=15cd406d&scoped=true&"
import script from "./ProfileSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsForm.vue?vue&type=style&index=0&id=15cd406d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd406d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VRow,VSelect,VTextField})
